const SITE = 'SITE';
const LINE = 'LINE';
const DEVICE = 'DEVICE';

export default {
  SITE,
  LINE,
  DEVICE,
};
